import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { CookieService } from 'ngx-cookie';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { HttpTokenService } from './http_token_service';
declare var DDP_ENV: any;
@Injectable()
export class EcareSecurityService {
	loggedInuser: any = [];
	associatedClients: any = [];
	constructor(private _router: Router, private _http: Http, private cookieService: CookieService,
		private tokenService: HttpTokenService){
	}

	public getVersion() {
		return DDP_ENV.version;
	}

	public setUserDetails(user: any){
		this.loggedInuser = user;
		localStorage.setItem('user', JSON.stringify(this.loggedInuser));
	}

	public getUserDetails(){
		return JSON.parse(localStorage.getItem('user'));
	}

	public setClientId(clientId: string){
		localStorage.setItem('clientId', clientId);
	}

	public getClientId(){
		return localStorage.getItem('clientId');
	}

	public addToClientList(client: any){
		this.associatedClients.push(client);
		localStorage.setItem('clientList', JSON.stringify(this.associatedClients));
	}

	public getClientList(){
		return JSON.parse(localStorage.getItem('clientList'));
	}

	/* Initial check if user is logged in - for any further access, though Guard will verify again.*/
	isLoggedIn(){
		if(this.tokenService.checkCredentials()){
			this._router.navigate(['/dashboard']);
		}
	}

	/* Deleting cookie and redirecting to login */
  	logout() {
	    this.cleanUp();
	    this.loggedInuser = '';
	    this.associatedClients = [];
	    this._router.navigate(['/login']);
  	}

  	/* clean up on logout or just before login*/
  	cleanUp(){
	    this.cookieService.remove("ecare_access_token");
	    this.cookieService.remove("ecare_refresh_token");
	    localStorage.removeItem('clientId');
	    localStorage.removeItem('clientList');
	    this.associatedClients = [];
	    localStorage.removeItem('user');
	    localStorage.clear();
  	}

}
